import { createContext, useContext, useState, useCallback } from "react";
import DataService from "./ProfilService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false); // Track if user info is loaded

  const updateUser = useCallback(async () => {
    try {
      const response = await DataService.getMyInfo();
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setIsLoaded(true); // Mark as loaded
    }
  }, []);

  const resetUserInfo = () => {
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, setUser, updateUser, resetUserInfo, isLoaded, setIsLoaded }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};